export const cartExpireTime = 43200;
